var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMaintenance)?_c('div',{staticClass:"banner"},[_c('span',[_vm._v("RMA Portal is under maintenance. ")]),_c('span',{staticClass:"banner-link",on:{"click":_vm.maintenanceInfo}},[_vm._v("More Info")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }